<h2 mat-dialog-title class="title-refuse">Refuser le devis {{ data.devisReference }}</h2>

<mat-dialog-content>
  <p class="info-msg">
    Veuillez saisir le motif de refus. Cette information sera communiquée au CDC.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Motif de refus</mat-label>
      <textarea matInput
                formControlName="devisMotifRefus"
                rows="5"
                placeholder="Expliquez le motif de refus (minimum 10 caractères)…">
      </textarea>
      <mat-error *ngIf="form.get('devisMotifRefus')?.hasError('required')">
        Le motif de refus est obligatoire
      </mat-error>
      <mat-error *ngIf="form.get('devisMotifRefus')?.hasError('minlength')">
        Le motif doit contenir au moins 10 caractères
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="saving">Annuler</button>
  <button mat-raised-button color="warn"
          [disabled]="saving"
          (click)="onRefuser()">
    <mat-spinner *ngIf="saving" diameter="16" class="btn-spinner"></mat-spinner>
    Refuser
  </button>
</mat-dialog-actions>
